(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('PaymentMethodDialogController', PaymentMethodDialogController);

    PaymentMethodDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'PaymentMethod'];

    function PaymentMethodDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, PaymentMethod) {
        var vm = this;
        vm.paymentMethod = entity;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        var onSaveSuccess = function (result) {
            $scope.$emit('sigmasfApp:paymentMethodUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.paymentMethod.id !== null) {
                PaymentMethod.update(vm.paymentMethod, onSaveSuccess, onSaveError);
            } else {
                PaymentMethod.save(vm.paymentMethod, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
    }
})();
